import type { ApplicationAgentContractResponse } from '@acme/api';
import { Separator, renderFieldIfText } from '@acme/foundation';

export const AgentContractMainInfo = ({
  agentContract,
}: {
  agentContract: ApplicationAgentContractResponse | null;
}) => {
  if (!agentContract) return null;

  return (
    <>
      <Separator className="-mx-6" />
      <div className="flex flex-col gap-4">
        <div className="text-xl font-semibold text-gray-900">
          Данные о плательщике агента
        </div>

        <div className="grid grid-cols-3 gap-6">
          {renderFieldIfText(
            'Наименование организации',
            agentContract.agentPayerName
          )}
          {renderFieldIfText(
            'Страна отправителя',
            agentContract.agentPayerCountry?.name
          )}
        </div>
        {renderFieldIfText(
          'Наименование банка',
          agentContract.agentPayerBankName
        )}
      </div>
    </>
  );
};
